export default __webpack_public_path__ + "static/media/03.1b601f78.jpg";